import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from '../../components/Layout';
import Tabs from '../../ui/Tabs/Tabs';
import VehicleExport from './VehicleExport';
import Hiaza from './Hiaza';
import OwnershipTransfer from './OwnershipTransfer';
import Registration from './Registration';
import FreeDocument from './FreeDocument';
import SalesInvoice from './SalesInvoice';
import { useGovFleet } from './govFleet';

/*
 * Government Transactions: the letters and the sales invoice on one page, a tab each (owner, 18 Oct 2026 - it was a
 * hub opening a page per letter). The fleet is read once here for all tabs. A tab is opened only when first
 * chosen and then stays (hidden) while another is shown, so what was typed in it is kept. Each tab keeps its own
 * fields, saved browser data, PDF and permissions. The old page links open their tab (OLD_LINKS, App.js).
 */
export const GOV_TABS = [
    { id: 'vehicle-export', label: 'Vehicle Export', Page: VehicleExport },
    { id: 'hiaza', label: 'Hiaza', Page: Hiaza },
    { id: 'mulkiya', label: 'Mulkiya', Page: OwnershipTransfer },
    { id: 'registration', label: 'Registration', Page: Registration },
    { id: 'custom-document', label: 'Custom Document', Page: FreeDocument },
    { id: 'sales-invoice', label: 'Sales Invoice', Page: SalesInvoice },
];

/** The old page of each letter -> its tab. */
export const OLD_LINKS = {
    '/vehicle-export': 'vehicle-export',
    '/hiaza': 'hiaza',
    '/ownership-transfer': 'mulkiya',
    '/registration': 'registration',
    '/free-document': 'custom-document',
    '/sales-invoice': 'sales-invoice',
};

export const govTabPath = (tab) => `/government?tab=${tab}`;

const tabFromLink = (params) => {
    const asked = params.get('tab');
    return GOV_TABS.some((t) => t.id === asked) ? asked : GOV_TABS[0].id;
};

const GovernmentTransactions = () => {
    const [params, setParams] = useSearchParams();
    const tab = tabFromLink(params);
    const [opened, setOpened] = useState(() => [tab]);
    const fleet = useGovFleet();
    // while a tab builds its PDF the other tabs are locked: hiding its letters mid-capture would spoil the PDF
    const [busy, setBusy] = useState(false);
    const tabItems = GOV_TABS.map((t) => ({ ...t, disabled: busy && t.id !== tab }));

    const openTab = (id) => {
        setOpened((list) => (list.includes(id) ? list : [...list, id]));
        setParams({ tab: id }, { replace: true });   // a refresh or a copied link stays on the tab
    };
    // a link to another tab while the page is open (the old page links, the breadcrumb)
    if (!opened.includes(tab)) setOpened([...opened, tab]);

    return (
        <Layout
            title="Government Transactions"
            subtitle="Government letters and the sales invoice"
            showHome={true}>
            <Tabs items={tabItems} value={tab} onChange={openTab} label="Government transactions" idPrefix="gov-tab" className="gov-tabs mb-6" />
            {GOV_TABS.filter((t) => opened.includes(t.id)).map(({ id, Page }) => (
                <div key={id} role="tabpanel" id={`gov-tab-panel-${id}`} aria-labelledby={`gov-tab-${id}`} hidden={id !== tab}>
                    <Page fleet={fleet} onBusyChange={setBusy} />
                </div>
            ))}
            <style>{`
                .gov-tabs { justify-content: safe center; }
            `}</style>
        </Layout>
    );
};

export default GovernmentTransactions;
